import { Tab, Tabs, Typography, Grid } from '@material-ui/core';
import { FuncaoParticipante, GrupoAcesso } from 'common/genericTypes';
import { HorizontalAppBar } from 'components/horizontalAppBar';
import { LgSpace } from 'm2m.components';
import Aditamentos from 'pages/aprovacoes/aditamentos';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import InstrumentoFinanceiro from './instrumentosFinanceiros';
import Participantes from './participantes';
import Credenciados from './credenciados';
import { Button } from 'm2m.components';
import { RouteComponentProps, useHistory, useLocation } from 'react-router-dom';
import SolicitacoesInstrumentosEdicao from './instrumentosEdicao';

type ComponentParams = { modulo?: string, filtro?: string };
type ComponentState = { initialTab?: number };
type Props = RouteComponentProps<ComponentParams, {}, ComponentState>;

const Solicitacoes: React.FC<Props> = (props) => {
  const isUsuarioCustodiante = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Custodiante
  );
  const isParticipanteEmissor = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Emissor
  );
  const isParticipanteEscriturador = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Escriturador
  );
  const isParticipanteCredenciado = useSelector(
    (state: RootState) => state.auth.usuario.participante.funcao === FuncaoParticipante.Credenciado
  );

  const isUsuarioInterno = useSelector(
    (state: RootState) =>
      state.auth.usuario.grupoAcesso === GrupoAcesso.Operacoes ||
      state.auth.usuario.grupoAcesso === GrupoAcesso.CadastroOperacoes ||
      state.auth.usuario.grupoAcesso === GrupoAcesso.CadastroLeitura
  );

  const initialTab = props.location.state?.initialTab;
  const [tabValue, setTabValue] = useState(0);
  const [filtros, setFiltros] = useState<string>();

  const history = useHistory();

  useEffect(() => {
    if (props.match.params.filtro) {
      setFiltros(props.match.params.filtro);
    }

    if (initialTab) {
      setTabValue(initialTab);
    }
    
  }, []);

  return (
    <div style={{ marginRight: 40 }}>
      <Grid container justify={'space-between'} direction={'row'} alignItems={'center'}>
        <Typography variant="h1">{'Solicitações'}</Typography>
        {isUsuarioCustodiante && (
          <Button variant="contained" color="primary" onClick={() => history.push(`/gerenciar/participantes/cadastro`)}>
            {'Novo Participante'}
          </Button>
        )}
      </Grid>
      <LgSpace />
      <HorizontalAppBar>
        <Tabs indicatorColor="primary" value={tabValue} onChange={(_event, newTab) => setTabValue(newTab)}>
          <Tab label="Instrumentos Financeiros" value={0} />

          {!isParticipanteEmissor && !isParticipanteCredenciado && !isParticipanteEscriturador && (
            <Tab label="Participantes" value={1} />
          )}
          {!isUsuarioCustodiante && !isParticipanteEscriturador && <Tab label="Credenciados" value={2} />}
          {!isUsuarioCustodiante && <Tab label="Aditamentos" value={3} />}
          {isUsuarioInterno && (
            <Tab label="Edições" value={4} />
          )}
        </Tabs>
      </HorizontalAppBar>
      {tabValue === 0 && <InstrumentoFinanceiro />}
      {tabValue === 1 && <Participantes filtros={filtros} />}
      {tabValue === 2 && <Credenciados />}
      {tabValue === 3 && <Aditamentos />}
      {tabValue === 4 && <SolicitacoesInstrumentosEdicao />}
      <LgSpace />
    </div>
  );
};

export default Solicitacoes;
